import React, { useCallback } from 'react'
import { useUpdateLog } from 'utils/log'

import { FormTitleProps } from '../items/FormTitle'
import TextAreaLine, { TextAreaLineProps } from '../items/TextAreaLine'
import BaseGroup from './BaseGroup'

/**
 * 対象がTextAreaGroupProps型かチェックする
 * @param target チェック対象
 */
export const isTextAreaGroupProps = (
  target: any
): target is TextAreaGroupProps => {
  return target.text !== undefined && target.title !== undefined
}

/**
 * テキストエリア
 */
const TextAreaGroup: React.FC<TextAreaGroupProps> = (props) => {
  const changeInput = useCallback(
    (inputText: string): void => {
      const state = { ...props.text }
      state.inputText = props.text.maxLength
        ? inputText.substring(0, props.text.maxLength)
        : inputText

      props.setText && props.setText(state)
    },
    [props]
  )

  useUpdateLog(
    props.title,
    {
      title: props.title,
      isRequired: props.isRequired,
      text: props.text,
    },
    [props]
  )

  return (
    <BaseGroup
      isRequired={props.isRequired}
      title={props.title}
      description={props.description}
      hideTitle={props.hideTitle}
    >
      <TextAreaLine
        {...props.text}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>): void => {
          changeInput(event.target.value)
        }}
      />
    </BaseGroup>
  )
}

export type TextAreaGroupProps = FormTitleProps & {
  text: TextAreaLineProps
  formName: string
  setText?: (text: TextAreaLineProps) => void
}

export default React.memo<TextAreaGroupProps>(TextAreaGroup)
